import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useCapabilitiesStore } from '@/stores/capabilities'

/**
 * returns whether the button should be visible and enabled
 * based on the capabilities and the current state
 * - button `visible` if one of the `capabilities` is enabled
 * - button `enabled` if the current matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfMicrophoneButtonState = () => {
  const selfAudioMuted = useSelfMemberState({ subscriptionKey: 'audioMuted' })

  const selfMicrophoneCapabilityOff = useCapabilitiesStore(
    state => state.selfMicrophoneCapabilityOff,
  )
  const selfMicrophoneCapabilityOn = useCapabilitiesStore(
    state => state.selfMicrophoneCapabilityOn,
  )

  // button visible if one of the capabilities is enabled
  const isMicrophoneButtonVisible =
    selfMicrophoneCapabilityOn || selfMicrophoneCapabilityOff

  // muted and can unmute
  const canUnmute = selfAudioMuted && selfMicrophoneCapabilityOn

  // unmuted and can mute
  const canMute = !selfAudioMuted && selfMicrophoneCapabilityOff

  // check if button can perform the necessary next action
  const isMicrophoneEnabled = canMute || canUnmute

  return {
    isMicrophoneButtonVisible,
    isMicrophoneEnabled,
  }
}
